// Modal.js

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SourceDto, MonsterDto, TranslatedText } from "../../../Types/ApiTypes";
import { getAllSources } from "../../../Utils/LocalApi";
import MonsterModalListComponent from "./MonsterModalListComponent";
import MonsterSpellGroupComponent from "./MonsterSpellGroupComponent";
import { getTranslation } from "../../../Utils/Converters";

interface MonsterModalTabProps{
    monster: MonsterDto,
    setMonster: (monster: MonsterDto) => void,
    language: string
}

const MonsterModalTab = (props: MonsterModalTabProps) => {
    const { t } = useTranslation();
    const [allSources, setAllSources] = useState([] as SourceDto[])
    useEffect(() => {
        getAllSources().then(setAllSources);
    },[]);
    return (
        <div className="d-flex flex-wrap text-center">
            <div className="d-flex col-3 p-2">
                <span className="col-4 pe-2">{t("monstermodal-index")}</span>
                <span className="col-8"><input 
                    value={props.monster.index}
                    type="text"
                    className="form-control"
                    name="index"
                    onChange={(e) => {
                        props.monster.index = e.target.value;
                        props.setMonster({...props.monster})
                    }}
                ></input></span>
            </div>
            <div className="d-flex col-3 p-2">
                <span className="col-4 pe-2">{t("monstermodal-source")}</span>
                <span className="col-8">
                    <select 
                        value={props.monster.source ? props.monster.source.id : 0}
                        className="form-control"
                        name="index"
                        onChange={(e) => {
                            props.monster.source = allSources.filter(s => {return s.id! === parseInt(e.target.value)})[0];
                            props.setMonster({...props.monster})
                        }}
                    >
                        {allSources.map((source) => {
                            return(
                                <option key={source.id} value={source.id}>{(source.year > 0 ? source.year : "")+" "+getTranslation(source.name, props.language)}</option>
                            )
                        })}
                    </select>
                </span>
            </div>
            <div className="d-flex col-6 p-2">
                <span className="col-2 pe-2">{t("monstermodal-name")}</span>
                <span className="col-10">
                    <span className="input-group">
                        <input 
                            value={getTranslation(props.monster.name, props.language)}
                            type="text"
                            className="form-control"
                            name="name-en"
                            onChange={(e) => {
                                props.monster.name[props.language] = e.target.value;
                                props.setMonster({...props.monster})
                            }}
                        ></input>
                    </span>
                </span>
            </div>
            <div className="d-flex col-6 p-2">
                <span className="col-2">{t("monstermodal-size")}</span>
                <span className="col-4">
                    <input 
                        value={getTranslation(props.monster.size, props.language)}
                        type="text"
                        className="col-6 form-control text-center"
                        name="level"
                        onChange={(e) =>{
                                props.monster.size[props.language] = e.target.value;
                                props.setMonster({...props.monster})
                            }
                        }
                    ></input>
                </span>
                <span className="col-2">{t("monstermodal-type")}</span>
                <span className="col-4">
                <input 
                        value={getTranslation(props.monster.type, props.language)}
                        type="text"
                        className="col-6 form-control text-center"
                        name="level"
                        onChange={(e) =>{
                                props.monster.type[props.language] = e.target.value;
                                props.setMonster({...props.monster})
                            }
                        }
                    ></input>
                </span>
            </div>
            
            <div className="d-flex col-6 p-2">
                <span className="col-2 pe-2">{t("monstermodal-alignment")}</span>
                <span className="col-10">
                    <span className="input-group">
                        <input 
                            value={getTranslation(props.monster.alignment, props.language)}
                            type="text"
                            className="form-control"
                            name="castingTime-en"
                            onChange={(e) => {
                                props.monster.alignment[props.language] = e.target.value;
                                props.setMonster({...props.monster})
                            }}
                        ></input>
                    </span>
                </span>
            </div>

            <div className="d-flex col-6 p-2">
                <span className="col-2">{t("monstermodal-ac")}</span>
                <span className="col-4">
                <input 
                        value={props.monster.armorClass}
                        type="number"
                        className="col-6 form-control text-center"
                        name="level"
                        onChange={(e) =>{
                            props.monster.armorClass = parseInt(e.target.value);
                            props.setMonster({...props.monster})
                        }}
                    ></input>
                </span>
                <span className="col-2">{t("monstermodal-hp")}</span>
                <span className="col-4">
                    <input 
                        value={props.monster.hitPoints}
                        type="number"
                        className="col-6 form-control text-center"
                        name="level"
                        onChange={(e) =>{
                            props.monster.hitPoints = parseInt(e.target.value);
                            props.setMonster({...props.monster})
                        }}
                    ></input>
                </span>
            </div>

            <div className="d-flex col-6 p-2">
                <span className="col-3">{t("spellmodal-proficiencybonus")}</span>
                <span className="col-1"><input 
                    value={props.monster.proficiencyBonus}
                    type="number"
                    className="col-6 form-control text-center"
                    name="level"
                    onChange={(e) => props.setMonster({...props.monster,"proficiencyBonus": parseInt(e.target.value)})}
                ></input></span>
                <span className="col-3">{t("spellmodal-passiveperception")}</span>
                <span className="col-1"><input 
                    value={props.monster.passivePerception}
                    type="number"
                    className="col-6 form-control text-center"
                    name="level"
                    onChange={(e) => props.setMonster({...props.monster,"passivePerception": parseInt(e.target.value)})}
                ></input></span>
                <span className="col-3">{t("spellmodal-hasspellcasting")}</span>
                <span className="col-1">
                {/* <span><input name="reaction" type="checkbox" class="form-check-input" style="max-width: 24px; max-height: 24px; outline-style: auto; outline-color: darkgray;"></span> */}
                    <span className="">
                        <input 
                            className="form-check-input"
                            style={{maxWidth: "24px", maxHeight: "24px", outlineStyle:"auto", outlineColor: "darkgray"}}
                            type="checkbox"
                            checked={props.monster.hasSpellCasting}
                            name="v"
                            onChange={e => {
                                props.setMonster({...props.monster,"hasSpellCasting": e.target.checked});
                            }}
                        ></input>
                    </span>
                </span>
            </div>
            
            <div className="d-flex col-6 p-2">
                <span className="col-2 pe-2">{t("monstermodal-languages")}</span>
                <span className="col-10">
                    <span className="input-group">
                        <input 
                            value={getTranslation(props.monster.languages, props.language)}
                            type="text"
                            className="form-control"
                            name="languages"
                            onChange={(e) => {
                                props.monster.languages[props.language] = e.target.value;
                                props.setMonster({...props.monster})
                            }}
                        ></input>
                    </span>
                </span>
            </div>

            <div className="col-6 p-2 d-flex">
                <span className="col-2 pe-2">{t("monstermodal-challenge")}</span>
                <span className="input-group">
                    <input 
                        value={props.monster.challengeCr}
                        type="number"
                        className="form-control text-center"
                        name="challenge-cr"
                        onChange={(e) => {
                            props.monster.challengeCr = parseFloat(e.target.value);
                            props.setMonster({...props.monster})
                        }}
                    ></input>
                    <span className="input-group-text">CR</span>
                    <input 
                        value={props.monster.challengeXP}
                        type="number"
                        className="form-control text-center"
                        name="challenge-XP"
                        onChange={(e) => {
                            props.monster.challengeXP = parseInt(e.target.value);
                            props.setMonster({...props.monster})
                        }}
                    ></input>
                    <span className="input-group-text">XP</span>
                    <input 
                        value={props.monster.challengePB}
                        type="number"
                        className="form-control text-center"
                        name="challenge-PB"
                        onChange={(e) => {
                            props.monster.challengePB = parseInt(e.target.value);
                            props.setMonster({...props.monster})
                        }}
                    ></input>
                    <span className="input-group-text">PB</span>
                    <input 
                        value={getTranslation(props.monster.challenge, props.language)}
                        type="text"
                        className="form-control text-center"
                        name="challenge"
                        onChange={(e) => {
                            props.monster.challenge[props.language] = e.target.value;
                            props.setMonster({...props.monster})
                        }}
                    ></input>
                </span>
            </div>
            <div className="d-flex col-6 p-2">
                <span className="col-2 pe-2">{t("monstermodal-skills")}</span>
                <span className="col-10">
                    <span className="input-group">
                        <input 
                            value={props.monster.skills ? getTranslation(props.monster.skills, props.language) : ""}
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                                props.monster.skills[props.language] = e.target.value;
                                props.setMonster({...props.monster})
                            }}
                        ></input>
                    </span>
                </span>
            </div>
            <div className="d-flex col-6 p-2">
                <span className="col-2 pe-2">{t("monstermodal-equipmentText")}</span>
                <span className="col-10">
                    <span className="input-group">
                        <input 
                            value={getTranslation(props.monster.equipmentText, props.language)}
                            type="text"
                            className="form-control"
                            name="otherRange-en"
                            onChange={(e) => {
                                props.monster.equipmentText[props.language] = e.target.value;
                                props.setMonster({...props.monster})
                            }}
                        ></input>
                    </span>
                </span>
            </div>

            <div className="d-flex col-12 px-2 flex-column">
                <details className=" col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-speed")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">
                        <div className="col-6 px-2 d-flex">
                            <span className="col-2 pe-2">{t("monstermodal-walkDistance")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.walkDistance? props.monster.walkDistance.mt : 0}
                                    type="number"
                                    className="form-control text-center"
                                    name="rangeAreaM"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"walkDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">m</span>
                                <input 
                                    value={props.monster.walkDistance? props.monster.walkDistance.ft : 0}
                                    name="rangeAreaFt"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"walkDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">ft</span>
                                <input 
                                    value={props.monster.walkDistance? props.monster.walkDistance.sq : 0}
                                    name="rangeAreaSq"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"walkDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("sq")}</span>
                            </span>
                        </div>
                        <div className="col-6 px-2 d-flex">
                            <span className="col-2 pe-2">{t("monstermodal-flyDistance")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.flyDistance? props.monster.flyDistance.mt : 0}
                                    type="number"
                                    className="form-control text-center"
                                    name="rangeAreaM"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"flyDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">m</span>
                                <input 
                                    value={props.monster.flyDistance? props.monster.flyDistance.ft : 0}
                                    name="rangeAreaFt"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"flyDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">ft</span>
                                <input 
                                    value={props.monster.flyDistance? props.monster.flyDistance.sq : 0}
                                    name="rangeAreaSq"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"flyDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("sq")}</span>
                            </span>
                        </div>
                        <div className="col-6 px-2 d-flex">
                            <span className="col-2 pe-2">{t("monstermodal-swimDistance")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.swimDistance? props.monster.swimDistance.mt : 0}
                                    type="number"
                                    className="form-control text-center"
                                    name="rangeAreaM"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"swimDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">m</span>
                                <input 
                                    value={props.monster.swimDistance? props.monster.swimDistance.ft : 0}
                                    name="rangeAreaFt"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"swimDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">ft</span>
                                <input 
                                    value={props.monster.swimDistance? props.monster.swimDistance.sq : 0}
                                    name="rangeAreaSq"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"swimDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("sq")}</span>
                            </span>
                        </div>
                        <div className="col-6 px-2 d-flex">
                            <span className="col-2 pe-2">{t("monstermodal-climbDistance")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.climbDistance? props.monster.climbDistance.mt : 0}
                                    type="number"
                                    className="form-control text-center"
                                    name="rangeAreaM"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"climbDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">m</span>
                                <input 
                                    value={props.monster.climbDistance? props.monster.climbDistance.ft : 0}
                                    name="rangeAreaFt"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"climbDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">ft</span>
                                <input 
                                    value={props.monster.climbDistance? props.monster.climbDistance.sq : 0}
                                    name="rangeAreaSq"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"climbDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("sq")}</span>
                            </span>
                        </div>
                        <div className="col-6 px-2 d-flex">
                            <span className="col-2 pe-2">{t("monstermodal-burrowDistance")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.burrowDistance? props.monster.burrowDistance.mt : 0}
                                    type="number"
                                    className="form-control text-center"
                                    name="rangeAreaM"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"burrowDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">m</span>
                                <input 
                                    value={props.monster.burrowDistance? props.monster.burrowDistance.ft : 0}
                                    name="rangeAreaFt"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"burrowDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                    }}
                                ></input>
                                <span className="input-group-text">ft</span>
                                <input 
                                    value={props.monster.burrowDistance? props.monster.burrowDistance.sq : 0}
                                    name="rangeAreaSq"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"burrowDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("sq")}</span>
                            </span>
                        </div>
                        <div className="col-6 px-2 d-flex">
                            <span className="col-2 pe-2">{t("monstermodal-otherdistance")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={getTranslation(props.monster.otherDistance, props.language)}
                                        type="text"
                                        className="form-control"
                                        name="castingTime-en"
                                        onChange={(e) => {
                                            props.monster.otherDistance[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>
                    </summary>
                </details>
            </div>

            <div className="d-flex flex-wrap col-6 px-2">
                {/* STATS */}
                <details className=" col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-stats")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">
                        <div className="col-6 d-flex px-2">
                            <span className="col-4 pe-2">{t("monstermodal-statStr")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.statStr}
                                    type="number"
                                    className="form-control text-center"
                                    name="statStr"
                                    onChange={e => {
                                        let value = parseInt(e.target.value);
                                        props.setMonster({...props.monster,"statStr": value});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("monstermodal-save")}</span>
                                <input 
                                    value={props.monster.saveStr}
                                    name="saveStr"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"saveStr": value});
                                    }}
                                ></input>
                            </span>
                        </div>
                        <div className="col-6 d-flex px-2">
                            <span className="col-4 pe-2">{t("monstermodal-statDex")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.statDex}
                                    type="number"
                                    className="form-control text-center"
                                    name="statDex"
                                    onChange={e => {
                                        let value = parseInt(e.target.value);
                                        props.setMonster({...props.monster,"statDex": value});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("monstermodal-save")}</span>
                                <input 
                                    value={props.monster.saveDex}
                                    name="saveDex"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"saveDex": value});
                                    }}
                                ></input>
                            </span>
                        </div>
                        <div className="col-6 d-flex px-2">
                            <span className="col-4 pe-2">{t("monstermodal-statCon")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.statCon}
                                    type="number"
                                    className="form-control text-center"
                                    name="statCon"
                                    onChange={e => {
                                        let value = parseInt(e.target.value);
                                        props.setMonster({...props.monster,"statCon": value});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("monstermodal-save")}</span>
                                <input 
                                    value={props.monster.saveCon}
                                    name="saveCon"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"saveCon": value});
                                    }}
                                ></input>
                            </span>
                        </div>
                        <div className="col-6 d-flex px-2">
                            <span className="col-4 pe-2">{t("monstermodal-statInt")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.statInt}
                                    type="number"
                                    className="form-control text-center"
                                    name="statInt"
                                    onChange={e => {
                                        let value = parseInt(e.target.value);
                                        props.setMonster({...props.monster,"statInt": value});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("monstermodal-save")}</span>
                                <input 
                                    value={props.monster.saveInt}
                                    name="saveInt"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"saveInt": value});
                                    }}
                                ></input>
                            </span>
                        </div>
                        <div className="col-6 d-flex px-2">
                            <span className="col-4 pe-2">{t("monstermodal-statWis")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.statWis}
                                    type="number"
                                    className="form-control text-center"
                                    name="statWis"
                                    onChange={e => {
                                        let value = parseInt(e.target.value);
                                        props.setMonster({...props.monster,"statWis": value});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("monstermodal-save")}</span>
                                <input 
                                    value={props.monster.saveWis}
                                    name="saveWis"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"saveWis": value});
                                    }}
                                ></input>
                            </span>
                        </div>
                        <div className="col-6 d-flex px-2">
                            <span className="col-4 pe-2">{t("monstermodal-statCha")}</span>
                            <span className="input-group">
                                <input 
                                    value={props.monster.statCha}
                                    type="number"
                                    className="form-control text-center"
                                    name="statCha"
                                    onChange={e => {
                                        let value = parseInt(e.target.value);
                                        props.setMonster({...props.monster,"statCha": value});
                                    }}
                                ></input>
                                <span className="input-group-text">{t("monstermodal-save")}</span>
                                <input 
                                    value={props.monster.saveCha}
                                    name="saveCha"
                                    type="number"
                                    className="form-control text-center"
                                    onChange={e => {
                                        let value = parseFloat(e.target.value);
                                        props.setMonster({...props.monster,"saveCha": value});
                                    }}
                                ></input>
                            </span>
                        </div>
                    </summary>
                </details>         
            </div>
            
            <div className="col-12 d-flex px-2">
                <details className=" col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-vulnaribilitiesandimmunities")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">
                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-damagevulnerabilities")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={getTranslation(props.monster.damageVulnerabilities, props.language)}
                                        type="text"
                                        className="form-control"
                                        name="castingTime-en"
                                        onChange={(e) => {
                                            props.monster.damageVulnerabilities[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>

                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-damageresistances")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={getTranslation(props.monster.damageResistances, props.language)}
                                        type="text"
                                        className="form-control"
                                        name="castingTime-en"
                                        onChange={(e) => {
                                            props.monster.damageResistances[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>

                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-damageimmunities")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={getTranslation(props.monster.damageImmunities, props.language)}
                                        type="text"
                                        className="form-control"
                                        name="castingTime-en"
                                        onChange={(e) => {
                                            props.monster.damageImmunities[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>
                        
                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-conditionimmunities")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={getTranslation(props.monster.conditionImmunities, props.language)}
                                        type="text"
                                        className="form-control"
                                        name="castingTime-en"
                                        onChange={(e) => {
                                            props.monster.conditionImmunities[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>
                    </summary>
                </details>
            </div>

            <div className="col-12 d-flex px-2">
                <details className=" col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-senses")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">

                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-darkvisionDistance")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={props.monster.darkvisionDistance? props.monster.darkvisionDistance.mt : 0}
                                        type="number"
                                        className="form-control text-center col-1"
                                        name="rangeAreaM"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"darkvisionDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">m</span>
                                    <input 
                                        value={props.monster.darkvisionDistance? props.monster.darkvisionDistance.ft : 0}
                                        name="rangeAreaFt"
                                        type="number"
                                        className="form-control text-center"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"darkvisionDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">ft</span>
                                    <input 
                                        value={props.monster.darkvisionDistance? props.monster.darkvisionDistance.sq : 0}
                                        name="rangeAreaSq"
                                        type="number"
                                        className="form-control text-center"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"darkvisionDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">{t("sq")}</span>
                                </span>
                            </span>
                        </div>
                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-darkvisionText")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={props.monster.darkvisionText? getTranslation(props.monster.darkvisionText, props.language) : ""}
                                        type="text"
                                        className="form-control"
                                        name="otherRange-en"
                                        onChange={(e) => {
                                            props.monster.darkvisionText[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>
                        
                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-blindsightDistance")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={props.monster.blindsightDistance? props.monster.blindsightDistance.mt : 0}
                                        type="number"
                                        className="form-control text-center col-1"
                                        name="rangeAreaM"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"blindsightDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">m</span>
                                    <input 
                                        value={props.monster.blindsightDistance? props.monster.blindsightDistance.ft : 0}
                                        name="rangeAreaFt"
                                        type="number"
                                        className="form-control text-center"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"blindsightDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">ft</span>
                                    <input 
                                        value={props.monster.blindsightDistance? props.monster.blindsightDistance.sq : 0}
                                        name="rangeAreaSq"
                                        type="number"
                                        className="form-control text-center"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"blindsightDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">{t("sq")}</span>
                                </span>
                            </span>
                        </div>
                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-blindsightText")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={props.monster.blindsightText ? getTranslation(props.monster.blindsightText, props.language) : ""}
                                        type="text"
                                        className="form-control"
                                        name="otherRange-en"
                                        onChange={(e) => {
                                            props.monster.blindsightText[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>

                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-tremorsenseDistance")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={props.monster.tremorsenseDistance? props.monster.tremorsenseDistance.mt : 0}
                                        type="number"
                                        className="form-control text-center col-1"
                                        name="rangeAreaM"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"tremorsenseDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">m</span>
                                    <input 
                                        value={props.monster.tremorsenseDistance? props.monster.tremorsenseDistance.ft : 0}
                                        name="rangeAreaFt"
                                        type="number"
                                        className="form-control text-center"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"tremorsenseDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">ft</span>
                                    <input 
                                        value={props.monster.tremorsenseDistance? props.monster.tremorsenseDistance.sq : 0}
                                        name="rangeAreaSq"
                                        type="number"
                                        className="form-control text-center"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"tremorsenseDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">{t("sq")}</span>
                                </span>
                            </span>
                        </div>
                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-tremorsenseText")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={props.monster.tremorsenseText ? getTranslation(props.monster.tremorsenseText, props.language) : ""}
                                        type="text"
                                        className="form-control"
                                        name="otherRange-en"
                                        onChange={(e) => {
                                            props.monster.tremorsenseText[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>

                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-truesightDistance")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={props.monster.truesightDistance? props.monster.truesightDistance.mt : 0}
                                        type="number"
                                        className="form-control text-center col-1"
                                        name="rangeAreaM"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"truesightDistance": {"mt": value,"ft":(value / 1.5)*5,"sq":(value / 1.5)}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">m</span>
                                    <input 
                                        value={props.monster.truesightDistance? props.monster.truesightDistance.ft : 0}
                                        name="rangeAreaFt"
                                        type="number"
                                        className="form-control text-center"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"truesightDistance": {"mt": (value / 5)*1.5,"ft":value,"sq": (value / 5)}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">ft</span>
                                    <input 
                                        value={props.monster.truesightDistance? props.monster.truesightDistance.sq : 0}
                                        name="rangeAreaSq"
                                        type="number"
                                        className="form-control text-center"
                                        onChange={e => {
                                            let value = parseFloat(e.target.value);
                                            props.setMonster({...props.monster,"truesightDistance": {"mt": (value * 1.5),"ft":(value * 5),"sq": value}});
                                        }}
                                    ></input>
                                    <span className="input-group-text">{t("sq")}</span>
                                </span>
                            </span>
                        </div>
                        <div className="d-flex col-6 p-2">
                            <span className="col-2 pe-2">{t("monstermodal-truesightText")}</span>
                            <span className="col-10">
                                <span className="input-group">
                                    <input 
                                        value={props.monster.truesightText ? getTranslation(props.monster.truesightText, props.language) : ""}
                                        type="text"
                                        className="form-control"
                                        onChange={(e) => {
                                            props.monster.truesightText[props.language] = e.target.value;
                                            props.setMonster({...props.monster})
                                        }}
                                    ></input>
                                </span>
                            </span>
                        </div>
                    </summary>
                </details>
            </div>
            
            <div className="col-6 d-flex px-2">
                <details className="col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-traitsText")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">
                        <MonsterModalListComponent
                            // label={t("monstermodal-traitsText")}
                            language={props.language}
                            text={props.monster.traitsText}
                            updateText={(text: TranslatedText) => {
                                props.monster.traitsText = text;
                                props.setMonster({...props.monster})
                            }}
                            list={props.monster.traits}
                            updateList={(list) => {
                                props.monster.traits = list;
                                props.setMonster({...props.monster})
                            }}
                        />
                    </summary>
                </details>
            </div>
            <div className="col-6 d-flex px-2">
                <details className="col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-actionsText")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">
                        <MonsterModalListComponent
                            // label={t("monstermodal-actionsText")}
                            language={props.language}
                            text={props.monster.actionsText}
                            updateText={(text: TranslatedText) => {
                                props.monster.actionsText = text;
                                props.setMonster({...props.monster})
                            }}
                            list={props.monster.actions}
                            updateList={(list) => {
                                props.monster.actions = list;
                                props.setMonster({...props.monster})
                            }}
                        />
                    </summary>
                </details>
            </div>
            <div className="col-6 d-flex px-2">
                <details className="col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-bonusActionsText")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">
                        <MonsterModalListComponent
                            // label={t("monstermodal-bonusActionsText")}
                            language={props.language}
                            text={props.monster.bonusActionsText}
                            updateText={(text: TranslatedText) => {
                                props.monster.bonusActionsText = text;
                                props.setMonster({...props.monster})
                            }}
                            list={props.monster.bonusActions}
                            updateList={(list) => {
                                props.monster.bonusActions = list;
                                props.setMonster({...props.monster})
                            }}
                        />
                    </summary>
                </details>
            </div>
            <div className="col-6 d-flex px-2">
                <details className="col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-reactionsText")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">
                        <MonsterModalListComponent
                            // label={t("monstermodal-reactionsText")}
                            language={props.language}
                            text={props.monster.reactionsText}
                            updateText={(text: TranslatedText) => {
                                props.monster.reactionsText = text;
                                props.setMonster({...props.monster})
                            }}
                            list={props.monster.reactions}
                            updateList={(list) => {
                                props.monster.reactions = list;
                                props.setMonster({...props.monster})
                            }}
                        />
                    </summary>
                </details>
            </div>
            <div className="col-6 d-flex px-2">
                <details className="col-12">
                    <summary className="text-start p-2">
                        <span>{t("monstermodal-legendaryActionsText")}</span>
                    </summary>
                    <summary className="col-12 d-flex flex-wrap">
                        <MonsterModalListComponent
                            // label={t("monstermodal-legendaryActionsText")}
                            language={props.language}
                            text={props.monster.legendaryActionsText}
                            updateText={(text: TranslatedText) => {
                                props.monster.legendaryActionsText = text;
                                props.setMonster({...props.monster})
                            }}
                            list={props.monster.legendaryActions}
                            updateList={(list) => {
                                props.monster.legendaryActions = list;
                                props.setMonster({...props.monster})
                            }}
                        />
                    </summary>
                </details>
            </div>

            {props.monster.hasSpellCasting && 
                <div className="col-12 p-2 d-flex flex-wrap">
                    <details className="col-12">
                        <summary className="text-start p-2">
                            <span>{t("monstermodal-spellcasting")}</span>
                        </summary>
                        <summary className="col-12 d-flex flex-wrap">
                            <div className="d-flex col-6 p-2">
                                <span className="col-2 pe-2">{t("monstermodal-spellchar")}</span>
                                <span className="col-10">
                                    <span className="input-group">
                                        <input 
                                            value={getTranslation(props.monster.spellCharacteristic, props.language)}
                                            type="text"
                                            className="form-control"
                                            onChange={(e) => {
                                                props.monster.spellCharacteristic[props.language] = e.target.value;
                                                props.setMonster({...props.monster})
                                            }}
                                        ></input>
                                    </span>
                                </span>
                            </div>

                            <div className="d-flex col-3 p-2">
                                <span className="col-6 pe-2">{t("monstermodal-spellsave")}</span>
                                <span className="col-6">
                                    <span className="input-group">
                                        <input 
                                            value={props.monster.spellSave}
                                            type="text"
                                            className="form-control"
                                            onChange={(e) => {
                                                props.monster.spellSave = parseInt(e.target.value);
                                                props.setMonster({...props.monster})
                                            }}
                                        ></input>
                                    </span>
                                </span>
                            </div>

                            <div className="d-flex col-3 p-2">
                                <span className="col-6 pe-2">{t("monstermodal-spellattackmod")}</span>
                                <span className="col-6">
                                    <span className="input-group">
                                        <input 
                                            value={props.monster.spellAttackMod}
                                            type="text"
                                            className="form-control"
                                            onChange={(e) => {
                                                props.monster.spellAttackMod = parseInt(e.target.value);
                                                props.setMonster({...props.monster})
                                            }}
                                        ></input>
                                    </span>
                                </span>
                            </div>

                            <div className="col-12 d-flex p-2">
                                <span>{t("spell-spellgroups")}&nbsp;</span>
                                <span role="button" onClick={e=>{
                                    if ( props.monster.spellGroups && props.monster.spellGroups.length > 0){  
                                        let newspellGroups = structuredClone(props.monster.spellGroups);
                                        newspellGroups.splice(newspellGroups.length -1, 1);
                                        props.monster.spellGroups = newspellGroups;
                                        props.setMonster({...props.monster})
                                    }
                                }}>
                                    <i className="bi bi-dash-circle"></i>
                                </span>
                                &nbsp;
                                <span role="button" onClick={e=>{
                                    let newGroups;
                                    if (props.monster.spellGroups){
                                        newGroups = [...props.monster.spellGroups, {name: {en: "", it: ""}, hasSlotsGroup: false, hasSlotsEach: false, maxSlots: 0, spells:[]}];
                                        
                                    }else{
                                        newGroups = [{name: {en: "", it: ""}, hasSlotsGroup: false, hasSlotsEach: false, maxSlots: 0, spells:[]}];
                                    }
                                    props.monster.spellGroups = newGroups;
                                    props.setMonster({...props.monster})
                                }}>
                                    <i className="bi bi-plus-circle"></i>
                                </span>
                            </div>
                            <div className={'d-flex flex-wrap fs-6 col-12'}>
                            {props.monster.spellGroups && props.monster.spellGroups.map((spellGroup, index)=>{return(
                                <MonsterSpellGroupComponent 
                                    language={props.language}
                                    key={"spellGroup-"+index}
                                    index={index}
                                    spellGroup={spellGroup}
                                    updateSpellGroup={(newSpellGroup) => {
                                        spellGroup = newSpellGroup;
                                        props.setMonster({...props.monster})
                                    }}
                                />
                            )})}
                            </div>
                        </summary>
                    </details>
                </div>
            }
        </div> 

    )
}
export default MonsterModalTab;